import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { lpResponsiveStyles } from "./constants";
import { SpStoneMonument } from "./SpStoneMonument";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Link from "next/link";

const useStyles = makeStyles((theme) => {
  const backgroundStyle = lpResponsiveStyles(theme, (baseWidth) => ({
    paddingTop: `calc(${baseWidth} * 0.06)`,
    paddingBottom: `calc(${baseWidth} * 0.3)`,
  }));
  const bannerStyles = lpResponsiveStyles(theme, (baseWith) => ({
    marginBottom: `calc(${baseWith} * 0.1)`,
    padding: "0 10%",
  }));
  const contentArea = lpResponsiveStyles(theme, (baseWidth) => ({
    padding: `0 calc(${baseWidth} * 0.05)`,
  }));
  const bannerHeader = lpResponsiveStyles(theme, (baseWidth) => ({
    textAlign: "center",
    color: "white",
    margin: `calc(${baseWidth} * 0.2) 0 calc(${baseWidth} * 0.05)`,
  }));
  return {
    background: {
      backgroundImage: "url(/img/footer_bg--sp.png)",
      backgroundSize: "cover",
      ...backgroundStyle,
    },
    contentArea,
    bannerHeader,
    banner: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#000",
      ...bannerStyles,
    },
  };
});

type Props = {};
export const SpFooter: FC<Props> = (props: Props) => {
  const classes = useStyles(props);
  return (
    <div className={classes.background}>
      <div className={classes.contentArea}>
        <SpStoneMonument />
        <div className={classes.bannerHeader}>＼ こちらもチェック！ ／</div>
        <div className={classes.banner}>
          <a href="http://king-cr.jp/special/seitokai_G2/">
            <LazyLoadImage
              effect="opacity"
              src="/img/lp/official_link.png"
              width="100%"
            />
          </a>
        </div>
        <div className={classes.banner}>
          <Link href={process.env.LANDING_POINT as string}>
            <LazyLoadImage
              effect="opacity"
              src="/img/lp/animefund_link.png"
              width="100%"
              style={{ border: "1px solid #777" }}
            />
          </Link>
        </div>
        <div style={{fontSize: "11px", color: "white", textAlign: "center"}}>
          <p>© AnimeFund inc.</p>
        </div>
      </div>
    </div>
  );
};
